import { render, staticRenderFns } from "./ModuleVideo.vue?vue&type=template&id=15cd12d2&scoped=true"
import script from "./ModuleVideo.vue?vue&type=script&lang=js"
export * from "./ModuleVideo.vue?vue&type=script&lang=js"
import style0 from "./ModuleVideo.vue?vue&type=style&index=0&id=15cd12d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cd12d2",
  null
  
)

export default component.exports